import * as classNames from 'classnames'
import * as moment from 'moment'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import {
  IActiveTripResponseV2,
  ILastActiveTrips,
  ILastActiveTripsByStages,
  IMap,
  ITripStage,
  ITripStatus
} from '../../../types'
import * as utils from '../../../utils'
import ActiveTripsStatistic from '../ActiveTripsStatistic'
import DashboardItem from '../DashboardItem'

interface IFullListActiveTripsProps extends RouteComponentProps<any> {
  currentOrganizationId: string
  lastActiveTrips: ILastActiveTripsByStages
  trips: IMap<IActiveTripResponseV2>
  getActiveTrips: (organizationId: string, stage: string, numberOfRecords: number) => void
  getLastActiveTrips: (organizationId: string) => void
  resendRequest: (tripId: string) => void
  getManyStatusesById: (tripId: string) => Promise<ITripStatus[]>
}

interface IFullListActiveTripsState {
  stageValue: string
}

class FullListActiveTrips extends React.Component<IFullListActiveTripsProps, IFullListActiveTripsState> {
  constructor(props: IFullListActiveTripsProps) {
    super(props)
    this.state = {
      stageValue: ''
    }
  }

  public componentDidUpdate(prevProps: IFullListActiveTripsProps) {
    const stage = utils.tripStages.find((item: ITripStage) => this.props.location.pathname.includes(item.route))
    if (stage && stage.value && stage.value !== this.state.stageValue && this.props.lastActiveTrips[stage.value]) {
      this.setStage(stage.value, this.props.lastActiveTrips[stage.value].total)
    }
  }

  public componentWillReceiveProps(nextProps: IFullListActiveTripsProps) {
    const stage = utils.tripStages.find((item: ITripStage) => nextProps.location.pathname.includes(item.route))
    if (
      stage &&
      nextProps.lastActiveTrips &&
      nextProps.lastActiveTrips[stage.value] &&
      !this.props.lastActiveTrips[stage.value]
    ) {
      this.setStage(stage.value, nextProps.lastActiveTrips[stage.value].total)
    }
  }

  public componentWillMount() {
    this.props.getLastActiveTrips(this.props.currentOrganizationId)
  }

  public render() {
    return (
      <div className='pt2 pb2 px3'>
        <div className='flex bb-light-grey3'>
          {utils.tripStages.map(({ label, route, value }: ITripStage, key: number) => (
            <div
              className={classNames('col-3 cursor--pointer', {
                'bb-width-2 bb-style-solid bb-color-green': this.state.stageValue === value
              })}
              onClick={this.redirectTo(route)}
              key={key}
            >
              <div className='right-align h6 col-11 font-grey2 m-auto'>
                {this.countActiveTrips(this.props.lastActiveTrips, value)}
              </div>
              <div className='center h6 pb1 font-grey3'>{label}</div>
            </div>
          ))}
        </div>
        <ActiveTripsStatistic />
        <div className='mt2'>
          {Object.values(this.props.trips)
            .sort((itemX: any, itemY: any) => {
              const dateX = new Date(itemX.status.createdAt)
              const dateY = new Date(itemY.status.createdAt)
              return dateX < dateY ? -1 : dateX > dateY ? 1 : 0
            })
            .map((item: any, key: number) => (
              <DashboardItem
                key={key}
                trip={item}
                waitingTime={moment(new Date()).diff(new Date(item.status.createdAt), 'seconds')}
                getManyStatusesById={this.props.getManyStatusesById}
                resendRequest={this.resendRequest}
              />
            ))}
        </div>
      </div>
    )
  }

  private countActiveTrips = (items: ILastActiveTripsByStages, stageValue: string) => {
    if (!items || !stageValue) {
      return 0
    }
    const trips = Object.values(items).find((item: ILastActiveTrips) => item.stage === stageValue)
    return trips ? trips.total : 0
  }

  private redirectTo = (path: string) => () => {
    this.props.history.push(`${this.props.match.path}/${path}`)
  }

  private resendRequest = (tripId: string) => {
    this.props.resendRequest(tripId)
  }

  private setStage(stageValue: string, numberOfRecords: number) {
    this.props.getActiveTrips(this.props.currentOrganizationId, stageValue, numberOfRecords)
    this.setState({ stageValue })
  }
}

export default FullListActiveTrips



// WEBPACK FOOTER //
// ./src/components/trips/list/FullListActiveTrips.tsx